import {useContext} from 'react';
import {CompanyConfigContext, CompanyConfigDispatchContext} from './contexts';

export const useCompanyConfigState = () => {
  const context = useContext(CompanyConfigContext);
  if (!context) {
    throw new Error('useCompanyConfigState must be used within a CompanyConfigProvider');
  }
  return context;
};

export const useCompanyConfigDispatch = () => {
  const context = useContext(CompanyConfigDispatchContext);
  if (!context) {
    throw new Error('useCompanyConfigDispatch must be used within a CompanyConfigProvider');
  }
  return context;
};
